<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">PSI Comparison</h1>
      <p>
        The comparison of PSIs is relatively short, as the only thing to show in this page is the <b>call impact data</b>
        of each project. This is represented in the Graph in Figure 1,

      </p>

    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
